import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Helper',
  },
  {
    path: 'Floats',
    breadcrumbName: 'Floats',
  },
];

const Floats = () => {
  return (
    <>
      <PageHeader title="Floats" breadcrumb={{ routes }} subTitle="Floats-Value" style={{ padding: 10 }} />

      <div className="MF_area">
        <ul>
          <li>f_{`{value}`}</li>
        </ul>
        <ul>
          <li>left</li>
          <li>right</li>
          <li>none</li>
        </ul>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="f_left box">f_left</div>
<div class="f_none box">f_none</div>
<div class="f_right box">f_right</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}

export default Floats;
